import styled from 'styled-components/macro';
import {useHistory} from "react-router-dom";
import {MenuItem} from "@chakra-ui/react";
import {useActions, useModal, useSettings} from "../../store";
import {useSelector} from "react-redux";
import {useFeedback} from "../../store/feedback";
import useLogout from "../../api/logout";
import NavLink from "../nav_link";
import SaveFolders from "../save_folders";
import {themecolors} from "../../utils/themecolors";
import CreateCommunity from "../create_community";
import ProSubscribe from "../pro_subscribe";

const Heading = styled.div``;
const Separator = styled.div``;

const ProfileMenu = styled(({className}) => {
    const modal = useModal();
    const history = useHistory();
    const actions = useActions();
    const settings = useSettings();
    const handleTheme = async () => {
        const changes = {theme: settings.theme === 'light' ? 'dark' : 'light'};
        actions.settingsChanged(changes);
        modal.close();
    };

    const fullWidth = useSelector(({clientSettings}) => clientSettings.fullWidth);
    const {feedbackCh} = useFeedback(true);
    const logout = useLogout(feedbackCh);
    const handleSaved = () => {
        modal.open(SaveFolders);
    };
    const handleWidth = () => {
        actions.clientSettingsChanged({fullWidth: !fullWidth});
    };
    const handleLogout = async () => {
        try {
            await logout();
            history.replace('/');
        } catch {
        }
    };

    const handleCreateCommunity = (event) => {
        event.preventDefault();
        modal.open(CreateCommunity);
    };

    const {pro_tier} = useSettings();
    const handlePro = async () => {
        if (pro_tier === 0) {
            modal.open(ProSubscribe);
        } else {
            history.push('/settings?type=subscription');
        }
    }

    return (
        <div className={className}>
            <Heading>
                Account
            </Heading>
            <NavLink href={'/u/me'} react_route>
                <MenuItem padding='0 32px' minH='40px'>
                    <span>My Profile</span>
                </MenuItem>
            </NavLink>
            <MenuItem padding='0 32px' minH='40px' onClick={handlePro}>
                <span>Upgrade to Pro</span>
            </MenuItem>
            <Separator/>
            <Heading>
                Posts
            </Heading>
            <MenuItem padding='0 32px' minH='40px' onClick={handleSaved}>
                <span>Saved Posts</span>
            </MenuItem>
            <NavLink href={'/upvoted'} react_route>
                <MenuItem padding='0 32px' minH='40px'>
                    <span>Upvoted Posts</span>
                </MenuItem>
            </NavLink>
            <NavLink href={'/hidden'} react_route>
                <MenuItem padding='0 32px' minH='40px'>
                    <span>Hidden Posts</span>
                </MenuItem>
            </NavLink>
            <Separator/>
            <Heading>
                Preferences
            </Heading>
            <MenuItem padding='0 32px' minH='40px' onClick={handleWidth}>
                <span>Full Width</span>
            </MenuItem>
            <MenuItem padding='0 32px' minH='40px' onClick={handleTheme}>
                <span>Dark Mode</span>
            </MenuItem>
            <NavLink href={'/settings'} react_route>
                <MenuItem padding='0 32px' minH='40px'>
                    <span>Settings</span>
                </MenuItem>
            </NavLink>
            <Separator/>
            <MenuItem padding='0 32px' minH='40px' onClick={handleLogout}>
                <span>Logout</span>
            </MenuItem>
        </div>
    );
})`
  width: 264px;

  ${Separator} {
    width: 100%;
    height: 1px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_3 : 'rgb(219, 219, 219)'};
    margin: 8px 0 10px 0;
  }

  ${Heading} {
    padding: 4px 24px;
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? '#b0b0b0' : themecolors.light_high_impact_text};
    font-weight: 500;
    display: flex;
    align-items: center;
  }
`;

export default ProfileMenu;
